"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.changeRenderModeHandler = void 0;
var tslib_1 = require("tslib");
var effects_1 = require("redux-saga/effects");
var redux_batched_actions_1 = require("redux-batched-actions");
var commands_1 = require("../../commands");
var renderMode_1 = require("../../events/renderMode");
var renderMode_2 = require("../../store/renderMode");
var configSelectors_1 = require("../../store/config/configSelectors");
var resetDashboardHandler_1 = require("../dashboard/resetDashboardHandler");
var validateDrills_1 = require("../common/validateDrills");
var layoutSelectors_1 = require("../../store/layout/layoutSelectors");
var validateDrillToCustomUrlParams_1 = require("../common/validateDrillToCustomUrlParams");
var sdk_model_1 = require("@gooddata/sdk-model");
var loadInaccessibleDashboards_1 = require("../dashboard/initializeDashboardHandler/loadInaccessibleDashboards");
function changeRenderModeHandler(ctx, cmd) {
    var _a, renderMode, renderModeChangeOptions, correlationId, editModeEnabled, data, widgets;
    return tslib_1.__generator(this, function (_b) {
        switch (_b.label) {
            case 0:
                _a = cmd.payload, renderMode = _a.renderMode, renderModeChangeOptions = _a.renderModeChangeOptions, correlationId = cmd.correlationId;
                return [4 /*yield*/, effects_1.select(configSelectors_1.selectDashboardEditModeDevRollout)];
            case 1:
                editModeEnabled = _b.sent();
                if (!(renderMode === "view" || editModeEnabled)) return [3 /*break*/, 12];
                if (!renderModeChangeOptions.resetDashboard) return [3 /*break*/, 4];
                return [4 /*yield*/, effects_1.call(resetDashboardHandler_1.resetDashboardRuntime, ctx, commands_1.resetDashboard(correlationId))];
            case 2:
                data = _b.sent();
                return [4 /*yield*/, effects_1.put(redux_batched_actions_1.batchActions([data.batch, renderMode_2.renderModeActions.setRenderMode(renderMode), data.reset]))];
            case 3:
                _b.sent();
                return [3 /*break*/, 6];
            case 4: return [4 /*yield*/, effects_1.put(redux_batched_actions_1.batchActions([renderMode_2.renderModeActions.setRenderMode(renderMode)]))];
            case 5:
                _b.sent();
                _b.label = 6;
            case 6:
                if (!(renderMode === "edit")) return [3 /*break*/, 11];
                return [4 /*yield*/, effects_1.select(layoutSelectors_1.selectAllAnalyticalWidgets)];
            case 7:
                widgets = _b.sent();
                return [4 /*yield*/, effects_1.call(loadInaccessibleDashboards_1.loadInaccessibleDashboards, ctx, widgets)];
            case 8:
                _b.sent();
                return [4 /*yield*/, effects_1.call(validateDrills_1.validateDrills, ctx, cmd, widgets)];
            case 9:
                _b.sent();
                return [4 /*yield*/, effects_1.call(validateDrillToCustomUrlParams_1.validateDrillToCustomUrlParams, widgets.filter(sdk_model_1.isInsightWidget))];
            case 10:
                _b.sent();
                _b.label = 11;
            case 11: return [2 /*return*/, renderMode_1.renderModeChanged(ctx, renderMode, correlationId)];
            case 12: return [2 /*return*/, renderMode_1.renderModeChanged(ctx, "view", correlationId)];
        }
    });
}
exports.changeRenderModeHandler = changeRenderModeHandler;
//# sourceMappingURL=changeRenderModeHandler.js.map